<template>
  <div class="my-1 font-be-vietnam pageSearch" :class="topClass">
    <div class="topSearch">
      <div class="container">
        <div class="filter">
          <div class="row">
            <div class="col-12 col-md-12">
              <h3>Bộ lọc
                <span class="reset" @click="refreshData">Đặt lại</span>
              </h3>
            </div>
            <div class="col-12 col-md-12">
              <b-form-group>
                <template #label>
                  <label class="d-block font-weight-bolder">Từ khóa</label>
                </template>
                <b-input-group>
                  <vue-simple-suggest ref="suggest" v-model="localSearchQuery" display-attribute="title"
                    value-attribute="title" :list="fetchSuggesst" :max-suggestions="10" :min-length="3" :debounce="100"
                    @select="onSuggestSelect">
                    <input placeholder="Tìm kiếm theo tiêu đề và nội dung" type="text" @keydown="onResearch($event)">
                    <div slot="suggestion-item" slot-scope="scope">
                      <span v-html="boldenSuggestion(scope)"></span>
                    </div>

                  </vue-simple-suggest>
                  <b-input-group-append>
                    <b-button variant="primary" @click="updateSearchQuery">
                      <feather-icon icon="SearchIcon" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3">
              <b-form-group label="Thể loại">
                <template #label>
                  <label class="d-block font-weight-bolder">Thể loại</label>
                </template>
                <v-select v-model="article_type_id" :options="ArticleType" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Chuyên mục">
                <template #label>
                  <label class="d-block font-weight-bolder">Chuyên mục</label>
                </template>
                <v-select v-model="category_id" :options="all_cats" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Đơn vị lấy tin">
                <template #label>
                  <label class="d-block font-weight-bolder">Đơn vị lấy tin</label>
                </template>
                <v-select v-model="department_news" :options="dataDepartment" label="name" :reduce="(val) => val.code"
                  placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Ngày đăng">
                <template #label>
                  <label class="d-block font-weight-bolder">Ngày đăng</label>
                </template>
                <date-picker ref="datetime" v-model="loadDateRange" type="datetime" range :shortcuts="shortcuts"
                  :show-time-panel="false" format="DD/MM/YYYY" value-type="format"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy" />
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-3">
              <b-form-group label="Đơn vị">
                <template #label>
                  <label class="d-block font-weight-bolder">Đơn vị</label>
                </template>
                <v-select v-model="department_unit" :options="dataDepartment" label="name" :reduce="(val) => val.id"
                  placeholder="--Chọn--" @option:selecting="selectedOption" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Phòng ban">
                <template #label>
                  <label class="d-block font-weight-bolder">Phòng ban</label>
                </template>
                <v-select v-model="department_id" :options="dataPhongBan ? dataPhongBan : []" label="name"
                  :reduce="(val) => val.id" placeholder="--Chọn--" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Tác giả (Bút danh)">
                <template #label>
                  <label class="d-block font-weight-bolder">Tác giả (Bút danh)</label>
                </template>
                <b-form-input v-model="loadQueryAlias" placeholder="Tác giả" @keyup.enter="updateSearchQuery" />
              </b-form-group>
            </div>
            <div class="col-12 col-md-3">
              <b-form-group label="Lấy tin">
                <template #label>
                  <label class="d-block font-weight-bolder">Lấy tin</label>
                </template>
                <v-select v-model="article_get_id" :options="dataGet" label="name" :reduce="(val) => val.id"
                  placeholder="--Tất cả--" />
              </b-form-group>
            </div>
          </div>
        </div>

      </div>
    </div>
    <b-overlay :show="loading" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
      <div class="divSearch">
        <div class="container">

          <b-row v-if="total > 0">
            <div class="col-12">
              <div class="show_search">
                <div class="total d-none d-sm-block">
                  <h3>Danh sách</h3>
                  <p v-if="itemsData.length > 0" class="mb-0 text-muted font-weight-bolder"> Hiển thị {{ dataMeta.from }}
                    đến
                    {{
                      dataMeta.to }} tin trên {{ dataMeta.of }} tin </p>
                </div>
                <div class="show_option">
                  <ul>
                    <li class="sort">
                      <span class="d-none d-sm-block">Sắp xếp theo: </span>
                      <span>
                        <b-form-select v-model="sort_id" :reduce="(val) => val.value" :options="dataSort"
                          place-holder="--Chọn--" />
                      </span>
                    </li>

                    <li>
                      <b-button v-b-tooltip.hover variant="whites" :disabled="loading" class="excel"
                        @click="exportExcel($event)">
                        <feather-icon icon="DownloadIcon" />&nbsp;&nbsp; Excel </b-button>
                    </li>
                    <li>
                      <b-button variant="blue" class="text-white pl-1 pr-1" @click="updateSearchQuery">
                        <feather-icon icon="SearchIcon" />
                        Tìm kiếm</b-button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <b-col cols="12" sm="12" class="d-flex align-items-center justify-content-sm-end my-1">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" :limit="8" first-number
                last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>

          <!-- LIST VIEW -->
          <div class="home_post_list" :class="showMode === 'list' ? 'show' : 'hide'">
            <div v-for="(item, index) in itemsData" :key="index" class="card-body mb-5px d-flex list_item"
              style="border: 1px solid #E8E8E8; border-radius: 6px;">
              <div class="w-15 column_time">
                <div class="d-flex align-items-center">
                  <span class="iconClock" /> <span
                    class="font-size14-be-vietnam  text-dark text-center font-weight-600">{{
                      moment.unix(item._source.published_at).format('DD/MM/YYYY, HH:mm:ss') }}</span>
                </div>
                <div class="pt-5px">
                  <span class="text-dark-3 font-size14-be-vietnam"> <span class="iconFolder" /></span> <span
                    class="text-dark font-size14-be-vietnam font-weight-600">{{
                      capFirst(item._source.category.name) }}</span>
                </div>
              </div>
              <div class="w-60 column_content">
                <div class="d-flex">
                  <div class="div_img">
                    <router-link :to="{ name: 'home-view', params: { id: item._source.id, slug: item._source.slug } }"
                      class="link a_img" event @click.native.prevent="openPreviewModal(item)">
                      <b-img thumbnail :src="item._source.image" class="thumbnail_img p-0" />
                    </router-link>
                  </div>
                  <div class="pl-1 div_title">
                    <router-link :to="{ name: 'home-view', params: { id: item._source.id, slug: item._source.slug } }"
                      class="link" event @click.native.prevent="openPreviewModal(item)">
                      <div class=" text-wrap">
                        <span :class="renderClassTitleView2(item)">

                          <span v-html="getTitle(item)"></span>
                          <span v-if="item._source.hot" class="iconHotGif" />
                          <span v-if="item._source.list_user_get.user_ids.includes(user_id)" class="iconNewsRead" />
                        </span>
                      </div>
                    </router-link>
                    <div class="news-icon d-flex flex-row pt-5px">
                      <span v-for=" (type, key) in item._source.content_type" :key="key"
                        class="d-flex justify-content-between pr-5px">
                        <span v-if="type === 'audio'" class="iconAudioBlue" />
                        <span v-if="type === 'photo'" class="iconPhotoBlue" />
                        <span v-if="type === 'video'" class="iconVideoBlue" />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-25 column_author">
                <div class="d-flex">
                  <div class="text-dark font-size14-be-vietnam w-30">
                    <span class="text-dark font-size14-be-vietnam font-weight-600">Tác giả: </span>
                  </div>
                  <div class="w-70 d-flex">
                    <span class="text-primary font-weight-700 font-size14-be-vietnam">
                      {{ item._source.author.department_unit ? item._source.author.department_unit.code : '' }}
                      <span class="text-dark-3 font-size14-be-vietnam font-weigh-500">
                        {{ item._source.author ? '(' + (item._source.author.alias ? item._source.author.alias :
                          item._source.author.username) + ')' : '' }}
                      </span>
                    </span>
                  </div>
                </div>
                <div class="d-flex pt-5px">
                  <div class="text-dark font-size14-be-vietnam w-30 font-weight-600 mt-5px">
                    Ban lấy tin:
                  </div>
                  <div class="w-70 ">
                    <div class="d-flex flex-wrap">
                      <div v-for="(item, k ) in (item._source.department_unit)" :key="k"
                        class="parent mr-5px mt-5px mb-5px">
                        <span class="item_part font-weight-600  font-be-vietnam">{{ item.name }} ({{
                          item.childs.length }})</span>
                        <div v-if="item.childs.length > 0" class="item_child mt-5px p-1">
                          <span v-for="(child, index1) in item.childs" :key="index1"
                            class="item_part_child mr-5px flex-wrap font-be-vietnam"> {{ child.department_code }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- GRID VIEW -->
          <div class=" row d-flex" :class="showMode === 'grid' ? 'show' : 'hide'">
            <div v-for="(item, index) in itemsData " :key="index" class="col-5-item mb-1 pl-5px pr-5px">
              <router-link :to="{ name: 'home-view', params: { id: item._source.id, slug: item._source.slug } }"
                class="div_thumbnail" event @click.native.prevent="openPreviewModal(item)">
                <b-img thumbnail :src="item._source.image" />
              </router-link>
              <div class="padding-category font-be-vietnam font-weight-500 font-size14-be-vietnam"
                style="color: #086BB5;">
                {{ item._source.category ? capFirst(item._source.category.name) : '' }}</div>
              <div class="">
                <h3 class="news-title">
                  <router-link :to="{ name: 'home-view', params: { id: item._source.id, slug: item._source.slug } }"
                    class="link d-flex" event @click.native.prevent="openPreviewModal(item)">
                    <span class="trunc trunc-2" :class="renderClassTitleView(item)">{{ item._source.title }}
                      <span v-if="item._source.hot" class="iconHotGif" />
                      <span v-if="item._source.is_get" class="iconNewsRead" />
                    </span>
                  </router-link>
                </h3>
              </div>
              <div class="news-icon col-12 p-0">
                <div class="news-icon d-flex  ">
                  <div class="col-md-4 col-3 d-flex p-0">
                    <span v-for=" (type, key) in item._source.content_type" :key="key">
                      <span v-if="type === 'audio'" class="iconAudioBlue" />
                      <span v-if="type === 'photo'" class="iconPhotoBlue" />
                      <span v-if="type === 'video'" class="iconVideoBlue" />
                    </span>
                  </div>
                  <div class="col-md-8 col-9 d-flex p-0 justify-content-end">
                    <span> {{
                      moment.unix(item._source.published_at).format('DD/MM/YYYY, HH:mm:ss') }} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Pagination -->
          <b-row class="mt-2">
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-dark font-weight-600">{{ $t('show_to_entries', {
                from: dataMeta.from, to: dataMeta.to, of:
                  dataMeta.of
              }) }}</span>
            </b-col>
            <b-col v-if="total" cols="12" sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination v-model="currentPage" :total-rows="total" :per-page="perPage" :limit="8" first-number
                last-number class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-overlay>
    <!-- MODAL PREVIEW -->
    <ViewPopup :show-preview="showPreview" :article-id="articleId" @close="onPreviewHidden"
      @on-view-article="onViewArticle" @on-read-article="onReadArticle" />
  </div>
</div></template>
<script>
import {
  BOverlay,
  BRow,
  BCol,
  BImg,
  BButton,
  BPagination,
  BFormInput,
  BFormGroup,
  VBTooltip,
  BFormSelect,
  BInputGroupAppend, BInputGroup,
} from 'bootstrap-vue';
import {
  ref, watch, computed, onMounted, onBeforeUnmount,
} from '@vue/composition-api';
import vSelect from 'vue-select'
import moment from 'moment';
import Ripple from 'vue-ripple-directive';
import DatePicker from 'vue2-datepicker';
import { showToast, useRouter } from '@/@core/utils/utils';
import store from '@/store'
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/vi';
import useCategory from './useCategory';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import useJwt from '@/auth/jwt/useJwt';
export default {
  components: {
    BOverlay,
    BRow,
    BCol,
    BImg,
    BButton,
    BPagination,
    BFormInput,
    BFormSelect,
    BFormGroup,
    vSelect,
    BInputGroupAppend,
    BInputGroup,
    DatePicker,
    VueSimpleSuggest,
    ViewPopup: () => import(/* webpackPrefetch: true */ './ViewPopup.vue'),
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      dataParent: [],
      moment,
      disabled: false,
      topClass: ''
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.handleScroll)
  },
  watch: {
    loadDateRange(newDate, oldDate) {
      this.start_date = (newDate[0]) ? newDate[0] : ''
      this.end_date = (newDate[1]) ? newDate[1] : ''
      this.$refs.datetime.closePopup()
    },
  },
  setup(props, context) {
    const { route, router } = useRouter();
    const dataUser = useJwt.getUser();
    const user_id = ref(dataUser.id)
    const ArticleType = ref([])
    const all_cats = ref([])
    const article_type_id = ref('')
    const department_news = ref('')
    const loadQueryAlias = ref('')
    const alias = ref('')
    const unit_get_id = ref('')
    const article_get_id = ref('')
    const sort_id = ref(1)
    const filter = ref('')
    const date_range = ref('')

    const {
      loading,
      perPage,
      total,
      from,
      to,
      showMode,
      capFirst,
      renderClassTitleView,
      allowResetCurrentPage,
      allowRefetchPaginate,
      currentPage,
      searchQuery,
      localSearchQuery,
      itemsData,
      department_id,
      start_date,
      end_date,
      refListTable,
      dataDepartment,
      category_id,
      loadDateRange,
      //  updateSearchQuery,
      dataPhongBan,
      department_unit,
      shortcuts,
      onWindowScroll,
      articleId,
      articleData,
      showPreview,
      onViewArticle,
      onReadArticle,
    } = useCategory(context);

    // overide old setup
    perPage.value = 50

    const dataSort = ref([
      { value: 1, text: 'Ngày đăng' },
      { value: 2, text: 'Tiêu đề' },
    ])
    const dataGet = ref([
      { id: 1, name: 'Tin đã sử dụng' },
      { id: 2, name: 'Tin chưa sử dụng' },
    ])
    const fetchAll = (isPaginate) => {
      loading.value = true

      store.dispatch('home/searchElastic', {
        keyword: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        start_date: start_date.value,
        end_date: end_date.value,
        article_type_id: article_type_id.value,
        category_id: category_id.value,
        department_id: department_id.value,
        unit_get_id: unit_get_id.value,
        article_get_id: article_get_id.value,
        alias: alias.value,
        sort_id: sort_id.value,
        department_news: department_news.value,
        department_unit: department_unit.value,
        filter: filter.value,
      })
        .then(response => {
          loading.value = false
          const result = response.data;
          if (result.code === 200) {
            filter.value = 1
            total.value = result.data.total;
            itemsData.value = result.data.data

            if (result.data.config.all_cats.length > 0) {
              all_cats.value = result.data.config.all_cats;
            }

            dataPhongBan.value = (result.data.config.data_phongban.length > 0) ? result.data.config.data_phongban : []

            if (result.data.config.department.length > 0) {
              dataDepartment.value = result.data.config.department
            }
            if (result.data.config.articleType.length > 0) {
              ArticleType.value = result.data.config.articleType;
            }
          }
          // }
        })
    }
    const dataMeta = computed(() => {
      const localItemsCount = 50
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      }
    })
    const openPreviewModal = (item) => {
      articleId.value = item._source.id
      articleData.value = item._source
      showPreview.value = true
      articleData.value.is_view = true
      item._source.list_user_view.user_ids.push(user_id.value)
    }
    const onPreviewHidden = () => {
      showPreview.value = false
    }
    const onArticleGet = () => {
      // articleData.value.is_view = true
      item._source.list_user_get.user_ids.push(user_id.value)
    }
    const refreshData = () => {
      window.localStorage.removeItem('VOVAT-route-category')
      currentPage.value = 1
      loadDateRange.value = '';
      localSearchQuery.value = '';
      searchQuery.value = '';
      start_date.value = '';
      end_date.value = '';
      article_type_id.value = '';
      category_id.value = '';
      department_id.value = '';
      unit_get_id.value = ''
      article_get_id.value = ''
      loadQueryAlias.value = ''
      alias.value = ''
      sort_id.value = ''
      department_news.value = ''
      department_unit.value = ''
      console.log('localSearchQuery', context.refs.suggest.inputElement.value = '')

      fetchAll();
    }

    watch([searchQuery, alias, article_type_id, department_news, department_unit, department_id, start_date, end_date, category_id, article_get_id, sort_id], () => {
      //console.log('allowResetCurrentPage.value', allowResetCurrentPage.value);
      if (allowResetCurrentPage.value) {
        currentPage.value = 1
      }
      allowRefetchPaginate.value = true
      // console.log('loading.value', loading.value);
      if (!loading.value) {
        fetchAll();
      }
    });

    watch([currentPage], (newPage) => {
      // console.log('watch currentpage', newPage);
      if (!loading.value) {
        fetchAll();
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    });
    const updateSearchQuery = () => {
      alias.value = loadQueryAlias.value
      searchQuery.value = localSearchQuery.value

    }

    onMounted(() => {
      // console.log('onmouted', route.value);
      let dataCache = window.localStorage.getItem('VOVAT-route-category')
      dataCache = dataCache ? JSON.parse(dataCache) : null
      // console.log('dataCache: ', dataCache);
      if (dataCache && dataCache.path === route.value.path) {
        console.log('dataCache', dataCache)
        // console.log('dataCache.path === route.value.path', dataCache.path === route.value.path);
        currentPage.value = dataCache.query.currentPage
        searchQuery.value = dataCache.query.searchQuery
        localSearchQuery.value = dataCache.query.searchQuery
        article_type_id.value = dataCache.query.article_type_id
        department_news.value = dataCache.query.department_news
        department_unit.value = dataCache.query.department_unit
        department_id.value = dataCache.query.department_id
        start_date.value = dataCache.query.start_date
        end_date.value = dataCache.query.end_date
        loadDateRange.value = dataCache.query.loadDateRange
        category_id.value = dataCache.query.category_id
        article_get_id.value = dataCache.query.article_get_id
        sort_id.value = dataCache.query.sort_id
        alias.value = dataCache.query.alias
        loadQueryAlias.value = dataCache.query.alias
        setTimeout(() => {
          allowResetCurrentPage.value = true
          // console.log('reset allowResetCurrentPage', allowResetCurrentPage.value);
        }, 0);
        loading.value = false
        fetchAll()
      } else {
        fetchAll()
      }

      window.addEventListener('scroll', onWindowScroll)
    });

    onBeforeUnmount(() => {
      // console.log('onbeforeunmoundted', route.value);
      const dataCache = {
        path: route.value.path,
        name: route.value.name,
        params: route.value.params,
        query: {
          currentPage: currentPage.value,
          searchQuery: searchQuery.value,
          article_type_id: article_type_id.value,
          department_news: department_news.value,
          department_unit: department_unit.value,
          department_id: department_id.value,
          start_date: start_date.value,
          end_date: end_date.value,
          loadDateRange: loadDateRange.value,
          category_id: category_id.value,
          article_get_id: article_get_id.value,
          sort_id: sort_id.value,
          alias: alias.value,
        },
      }
      // console.log('dataCache', dataCache);
      window.localStorage.setItem('VOVAT-route-category', JSON.stringify(dataCache))

      window.removeEventListener('scroll', onWindowScroll);
    });

    const fetchSuggesst = (keyword) => {
      return store.dispatch('home/fechDataSuggest', {
        q: keyword
      }).then(response => {
        return response.data.data
      })
    }
    const onSuggestSelect = (suggest) => {
      searchQuery.value = suggest.title
    }

    const onResearch = (event) => {

      if (event.keyCode == 13) {
        searchQuery.value = event.target.value
      }
    }

    const renderClassTitleView2 = (item) => {
      // 1. Tin bình thường mầu đen
      // 2. Tin đã click màu ghi
      // 3. Tin hot màu đỏ tười có iconhot
      // 4. TIn đã lấy màu nâu đỏ có icon xanh
      // 5. Tin hot đã click màu ghi có icon hot
      // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
      let classTitle = 'class_title_detail_normall';
      if (item._source.hot) {
        if (item._source.list_user_get.user_ids.includes(user_id.value)) { // đã lấy thì đã đọc
          if (item._source.list_user_view.user_ids.includes(user_id.value)) {
            classTitle = 'class_title_detail_hot_get_view'
          } else {
            classTitle = 'class_title_detail_hot_get_notview'
          }
        } else if (!item._source.list_user_get.user_ids.includes(user_id.value)) { // tin chưa lấy những có thể đọc hoặc chưa đọc
          if (item._source.list_user_view.user_ids.includes(user_id.value)) {
            classTitle = 'class_title_detail_hot_notget_view'
          } else {
            classTitle = 'class_title_detail_hot_notget_notview' // tin hot chưa lấy chưa đọc
          }
        }
      } else if (!item._source.hot) {
        if (item._source.list_user_get.user_ids.includes(user_id.value)) { // tin đã lấy thì đã đọc
          if (item._source.list_user_view.user_ids.includes(user_id.value)) {
            classTitle = 'class_title_detail_nothot_get_view'
          } else {
            classTitle = 'class_title_detail_nothot_notget_notview'
          }
        } else if (!item._source.list_user_get.user_ids.includes(user_id.value)) {
          if (item._source.list_user_view.user_ids.includes(user_id.value)) { // tin bt nhưng đã xem chưa lấy
            classTitle = 'class_title_detail_nohot_notget_view'
          } else {
            classTitle = 'class_title_detail_nohot_notget_notview'
          }
        }
      }

      return classTitle;
    }

    return {
      articleId,
      articleData,
      onArticleGet,
      openPreviewModal,
      showPreview,
      onPreviewHidden,
      dataMeta,
      itemsData,
      currentPage,
      refreshData,
      refListTable,
      perPage,
      loading,
      total,
      showMode,
      capFirst,
      renderClassTitleView,
      ArticleType,
      all_cats,
      article_type_id,
      article_get_id,
      searchQuery,
      category_id,
      start_date,
      end_date,
      loadDateRange,
      alias,
      dataDepartment,
      department_id,
      dataGet,
      updateSearchQuery,
      localSearchQuery,
      loadQueryAlias,
      dataSort,
      sort_id,
      date_range,
      department_news,
      department_unit,
      dataPhongBan,
      shortcuts,
      onViewArticle,
      onReadArticle,
      fetchSuggesst,
      onResearch,
      onSuggestSelect,
      user_id,
      renderClassTitleView2
    }
  },
  methods: {
    handleScroll(e) {
      if (window.pageYOffset > 20) {
        this.topClass = 'fixtop';
      } else {
        this.topClass = '';
      }
    },
    getTitle(item) {
      let title = item._source.title
      if (item.highlight && item.highlight.title) {
        // <strong class="highlight">Vương</strong>
        title = item.highlight.title[0]
        // let number = title.match(/<strong class="highlight">(.*?)<\/strong>/g).length;
        let highlight = title.match(/<strong class="highlight">(.*?)<\/strong>/g).map(function (val, index) {
          return val.replace(/<[^>]*>?/gm, '');
        });
        title = title.replace(/<[^>]*>?/gm, '');
        let text_highlight = highlight.join(' ');
        title = title.replace(text_highlight, '<strong class="highlight"> ' + text_highlight + ' </strong>')
      }
      return item._source.article_type.code + ' - ' + title
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      let result = this.$refs.suggest.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|\.]/gm).filter(t => !!t) || [''];
      return result.replace(new RegExp('(.*?)(' + texts.join('|') + ')(.*?)', 'gi'), '$1<b>$2</b>$3');
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date < today || date > new Date(today.getTime() + 7 * 24 * 3600 * 1000);
    },
    selectedOption(val) {
      this.department_id = ''
    },
    exportExcel() {
      this.loading = true;
      this.disabled = true;

      store.dispatch('home/exportElastic', {
        keyword: this.searchQuery,
        department_id: this.department_id,
        start_date: this.start_date,
        end_date: this.end_date,
        article_type_id: this.article_type_id,
        category_id: this.category_id,
        department_id: this.department_id,
        unit_get_id: this.unit_get_id,
        article_get_id: this.article_get_id,
        alias: this.alias,
        sort_id: this.sort_id,
        total: this.total,
        department_news: this.department_news,
        department_unit: this.department_unit,

      }).then(response => {
        this.loading = false;
        if (response.data) {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const text_date = moment().format('YYYY-MM-DD.HH.mm')
          const fileName = `Thống kê số lượng tin bài ${text_date}.xlsx`;
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          this.disableBtn = false
          showToast('Tải file thành công', { variant: 'success' });
        } else {
          showToast('Lỗi tải file')
          this.disableBtn = false
        }
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';

.vue-simple-suggest {
  width: calc(100% - 58px);

  .input-wrapper input {
    padding: 0.6rem 1rem !important;
    border-color: #d8d6de !important;
    border-top-left-radius: 0.357rem !important;
    border-bottom-left-radius: 0.357rem !important;
  }

}
</style>
